<template>
  <div class="left-menu-wrapper">
    <MenuItem v-for="menu in menus" :key="menu.id" :menu="menu" />
    <PopupChangePaymentRequisites />
  </div>
</template>

<script>
import MenuItem from "@/components/atoms/menu-item/index.vue";
import PopupChangePaymentRequisites from "@/components/organisms/popup-change-payment-requisites";
import { mapState } from "vuex";

export default {
  name: "left-menu",
  components: {
    MenuItem,
    PopupChangePaymentRequisites,
  },
  computed: {
    ...mapState({
      menus: (state) => state.profileMenu.items,
    }),
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/fonts.scss";

.left-menu-wrapper {
  * {
    font-family: Inter, sans-serif;
  }
}

@media screen and (max-width: var.$md) {
  .left-menu-wrapper {
    display: none;
  }
}
</style>
